import { selectBlogList,selectProjectFiance,selectGoldProject,selectProjectByTag } from '../../services/finance';
export default {
  namespace: 'finance',
  state: {
    args: {pageNum:1},
    informationList:[],
    financingList:[],
    projectList:[],
    projectByTagList:[],
    isLoading:true,
    empty:'没有符合要求的项目',
    total:0,
    pageSize:0,
    pages:null,
    size:0
  },
  subscriptions: {
    // setup({ dispatch, history }) {}
  },
  
  effects: {
    //资讯
    * selectBlogList(a,{call,put}){
      let data = yield call(selectBlogList);
      if(data.success){
        yield put({
          type: 'current',
          payload: {
            informationList:data.data.blogItemListVO
          }
        });
      }
    },
    //翻页时获取当前表单已填内容
    *getArgs({ region }, { put, select }) {
      const argsData = yield select(state => {
        return Object.assign(state.finance.args?state.finance.args:{}, region);
      });
      yield put({ type: 'current', payload:{isLoading:true}});
      yield put({ type: region.type, payload: argsData });
    },
    //投融资事件
    * selectProjectFiance({payload},{call,put,select}){
      if(payload)delete payload.type;
      yield put({ type: 'current', payload: {args: payload} });
      let financingList = yield select(state => state.finance.financingList);
      let data = yield call(selectProjectFiance,payload);
      
      if(data.success){
        if(payload.onscroll && data.data.list){
          financingList = financingList.concat(data.data.list);
        }else if(data.data.list){
          financingList = data.data.list;
        }else{
          financingList = [];
        }
        yield put({
          type: 'current',
          payload: {
            financingList:financingList,
            isLoading : false,
            total:data.data.total,
            pageNum:data.data.pageNum,
            pageSize:data.data.pageSize,
            pages:data.data.pages
          }
        });
      }else{
        yield put({
          type: 'current',
          payload: {
            financingList: [],
            isLoading : false,
            total:0,
            empty:'啊哦，好像出错了'
          }
        });
      }
    },
    //项目列表
    *selectGoldProject({payload},{call,put,select}){
      if(payload)delete payload.type;
      yield put({ type: 'current', payload: {args: payload} });
      let projectList = yield select(state => state.finance.projectList);
      let data = yield call(selectGoldProject,payload);
      
      if(data.success){
        if(payload.onscroll && data.data.list){
          projectList = projectList.concat(data.data.list);
        }else if(data.data.list){
          projectList = data.data.list;
        }else{
          projectList = [];
        }
        yield put({
          type: 'current',
          payload: {
            projectList:projectList,
            isLoading : false,
            total:data.data.total,
            pageNum:data.data.pageNum,
            pageSize:data.data.pageSize,
            pages:data.data.pages
          }
        });
      }else{
        yield put({
          type: 'current',
          payload: {
            projectList: [],
            isLoading : false,
            total:0,
            empty:'啊哦，好像出错了'
          }
        });
      }
    },
    //标签查询项目
    * selectProjectByTag({payload},{call,put,select}){
      if(payload)delete payload.type;
      yield put({ type: 'current', payload: {args: payload}});
      let projectByTagList = yield select(state => state.finance.projectByTagList);
      let data = yield call(selectProjectByTag,payload);
      
      if(data.success){
        if(payload.onscroll && data.data.list){
          projectByTagList = projectByTagList.concat(data.data.list);
        }else if(data.data.list){
          projectByTagList = data.data.list;
        }else{
          projectByTagList = [];
        }
        yield put({
          type: 'current',
          payload: {
            projectByTagList:projectByTagList,
            isLoading : false,
            total:data.data.total,
            pageNum:data.data.pageNum,
            pageSize:data.data.pageSize,
            pages:data.data.pages,
            size:data.data.size
          }
        });
      }else{
        yield put({
          type: 'current',
          payload: {
            projectByTagList: [],
            isLoading : false,
            total:0,
            empty:'啊哦，好像出错了'
          }
        });
      }
    }
  },
  
  reducers: {
    // 当前数据
    current(state, { payload }) {
      return {...state,...payload};
    }
  }
    
};
  


// WEBPACK FOOTER //
// ./src/scripts/models/Finance/Finance.js